module.exports = __webpack_public_path__ + "static/media/nico-broker.170055fe.svg";